import axios from "axios";
import React, { useEffect, useState } from "react";
import { Config } from "../../../../../../../Config";

const CoreInfo = (props) => {
  const [EmpCoreInfo, setEmpCoreInfo] = useState();
  const [PositionInfo, setPositionInfo] = useState();

  useEffect(() => {
    fetchEmployeeCoreInfo();
    fetchPositionCoreInfo();
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const fetchEmployeeCoreInfo = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.EmpServiceURL +
        "/api/employee/preference-info/core",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setEmpCoreInfo(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchPositionCoreInfo = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/preference-info/core",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setPositionInfo(Res.data);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const checkForNull = (Item) => {
    if (Item === null) {
      return translateText("not_available");
    } else {
      return Item;
    }
  };
  return (
    <div className="core-info-wrapper">
      <h1 className="section-label">{translateText("employee_info")}</h1>
      {EmpCoreInfo === undefined ? null : (
        <section className="core-info-section">
          <div className="section-row">
            <p className="row-title">{translateText("email_address")}</p>
            <p className="row-info">{checkForNull(EmpCoreInfo.email)}</p>
          </div>
          <div className="section-row">
            <p className="row-title">{translateText("employee_id")}</p>
            <p className="row-info">
              {checkForNull(EmpCoreInfo.globalEmployeeCode)}
            </p>
          </div>
          <div className="section-row mobile-grid-row">
            <p className="row-title">{translateText("work_phone")}</p>
            <p className="row-info">{checkForNull(EmpCoreInfo.workPhone)}</p>
            <p className="row-info row-secondary">
              {checkForNull(EmpCoreInfo.workMobile)}
            </p>
          </div>
          <div className="section-row mobile-grid-row">
            <p className="row-title">{translateText("home_phone")}</p>
            <p className="row-info">{checkForNull(EmpCoreInfo.homePhone)}</p>
            <p className="row-info row-secondary">
              {checkForNull(EmpCoreInfo.homeMobile)}
            </p>
          </div>
          <div className="section-row">
            <p className="row-title">{translateText("homecity_country")}</p>
            <p className="row-info">
              {checkForNull(EmpCoreInfo.homeCity) +
                " / " +
                checkForNull(EmpCoreInfo.homeCountryCode)}
            </p>
          </div>
        </section>
      )}
      <div className="section-separator"></div>
      <h1 className="section-label">{translateText("position_info")}</h1>
      {PositionInfo === undefined ? null : (
        <section className="core-info-section">
          <div className="section-row">
            <p className="row-title">{translateText("position_job_id")}</p>
            <p className="row-info">
              {checkForNull(PositionInfo.globalPositionCode)}
            </p>
          </div>
          <div className="section-row">
            <p className="row-title">
              {translateText("jpa_owner_type_manager")}
            </p>
            <p className="row-info">
              {checkForNull(PositionInfo.supervisorGlobalPosCode)}
            </p>
          </div>
          <div className="section-row">
            <p className="row-title">{translateText("workcity_country")}</p>
            <p className="row-info">
              {checkForNull(PositionInfo.workCity) +
                " / " +
                checkForNull(PositionInfo.workCountryCode)}
            </p>
          </div>
          <div className="section-row">
            <p className="row-title">{translateText("business_unit")}</p>
            <p className="row-info">
              {checkForNull(PositionInfo.businessUnit)}
            </p>
          </div>
          <div className="section-row">
            <p className="row-title">{translateText("region")}</p>
            <p className="row-info">{checkForNull(PositionInfo.region)}</p>
          </div>
          <div className="section-row">
            <p className="row-title">{translateText("country")}</p>
            <p className="row-info">{checkForNull(PositionInfo.country)}</p>
          </div>
          <div className="section-row">
            <p className="row-title">{translateText("department")}</p>
            <p className="row-info">{checkForNull(PositionInfo.department)}</p>
          </div>
        </section>
      )}
    </div>
  );
};

export default CoreInfo;
